<template>
	<v-container class="h-100">
		<v-alert v-if="errors.user_id" type="error" class="mb-4">{{ errors.user_id }}</v-alert>
		<v-text-field
			type="password"
			:label="$t('member.current_password')"
			v-model="form.oldpassword"
			:error-messages="errors.oldpassword"
		/>
		<v-text-field
			type="password"
			:label="$t('member.new_password')"
			v-model="form.newpassword"
			:error-messages="errors.newpassword"
		/>
		<v-text-field
			type="password"
			:label="$t('member.new_password_confirm')"
			v-model="form.passwordconfirm"
			:error-messages="errors.passwordconfirm"
		/>
		<v-btn @click.stop="submit" block color="primary" class="white--text">
			{{ $t('common.confirm') }}
		</v-btn>
	</v-container>
</template>

<script>
import { sha256 } from 'js-sha256'
import { clone } from 'lodash-es'

export default {
	name: 'ModifyPasswordForm',
	props: {
		value: {
			type: Object,
			default: () => ({})
		}
	},
	data() {
		return {
			form: {},
			errors: {}
		}
	},
	mounted() {
		this.form = clone(this.value)
	},
	watch: {
		value(nv) {
			this.form = clone(nv)
		}
	},
	methods: {
		submit() {
			console.log(this.form)
			this.$api.user.modifyPassword(
				{
					user_id: this.form.user_id,
					oldpassword: sha256(this.form.oldpassword),
					newpassword: sha256(this.form.newpassword),
					passwordconfirm: sha256(this.form.passwordconfirm)
				},
				(response) => {
					alert('修改成功，请重新登录')
					this.$emit('success', response)
					// this.$store.dispatch('visitor/logout')
					// this.$store.commit('showLogin', true)
				},
				(err) => {
					this.$emit('error', err)
					this.errors = err.data
					alert(err.message)
				}
			)
		}
	},
	computed: {},
	components: {}
}
</script>
<style></style>
